import { CollectionPage } from '../components/collection/CollectionPage'

import { PageTemplateProps } from './page-templates.types'

export default function CollectionPageTemplate({ pageData }: PageTemplateProps) {
  const pageDataJson = pageData.context.pageDataJson
  return <CollectionPage collectionPage={pageDataJson} />
}
